import Vue from 'vue'
import App from './App.vue'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import { SurveyBuilder } from 'vue-survey-builder';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.config.productionTip = false
// Vue.prototype.$apiAdress = 'http://ec2-18-118-112-130.us-east-2.compute.amazonaws.com'
// Vue.prototype.$apiAdress = 'http://127.0.0.1:8000'
Vue.prototype.$apiAdress = 'https://exodus-app.herokuapp.com'
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.component('SurveyBuilder', SurveyBuilder)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
})
